/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function AuditPriorityTriangle12(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'AuditPriorityTriangle12',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"m1.66 8.49 3.43-6.025c.42-.62 1.4-.62 1.82 0l3.43 6.026c.44.66-.07 1.509-.91 1.509H2.57c-.84 0-1.35-.85-.91-1.51","fill":"currentColor"}))
}
